import TRAINING_CATEGORIES from "../TrainingCoursePage/_trainingCategories";
import {
  FORMAT_OPTIONS,
  getCategoryLabel,
  getFormatLabel,
  toggle,
} from "../TrainingCoursePage/_trainingUtils";
import { createTranslator } from "../../utils/translate";
import de from "./de.json";
import en from "./en.json";

const translations = { de, en };

const ToggleButton = ({ active, onClick, children }) => (
  <button
    type="button"
    className={`btn btn-sm me-2 mb-2 ${
      active ? "bg-blue" : "btn-outline-gray"
    }`}
    onClick={onClick}
  >
    {children}
  </button>
);

const FilterGroup = ({ label, children }) => (
  <div>
    <div className="fw-semibold mb-2 small text-uppercase text-blue">
      {label}
    </div>
    {children}
  </div>
);

const TrainingFilterPanel = ({
  filterCategories,
  setFilterCategories,
  filterFormats,
  setFilterFormats,
  filterFreeOnly,
  setFilterFreeOnly,
  showExpired,
  setShowExpired,
  hasActiveFilters,
  onReset,
  onScrollToTable,
  language,
}) => {
  const t = createTranslator(language, translations);
  return (
    <div className="row mb-3 g-3 bg-white p-3 rounded">
      <div className="col-12">
        <h3 className="filter-header">{t("filterHeading")}</h3>
        <FilterGroup label={t("category")}>
          <ToggleButton
            active={filterCategories.length === 0}
            onClick={() => setFilterCategories([])}
          >
            {t("all")}
          </ToggleButton>
          {TRAINING_CATEGORIES.map((c) => (
            <ToggleButton
              key={c.key}
              active={filterCategories.includes(c.key)}
              onClick={() =>
                setFilterCategories(toggle(filterCategories, c.key))
              }
            >
              {getCategoryLabel(c.key, language)}
            </ToggleButton>
          ))}
        </FilterGroup>
      </div>

      <div className="col-12 col-md-6">
        <FilterGroup label={t("format")}>
          {FORMAT_OPTIONS.map((f) => (
            <ToggleButton
              key={f.key}
              active={filterFormats.includes(f.key)}
              onClick={() => setFilterFormats(toggle(filterFormats, f.key))}
            >
              {getFormatLabel(f.key, language)}
            </ToggleButton>
          ))}
        </FilterGroup>
      </div>

      <div className="col-12 col-md-6">
        <FilterGroup label={t("availability")}>
          <ToggleButton
            active={filterFreeOnly}
            onClick={() => setFilterFreeOnly(!filterFreeOnly)}
          >
            {t("onlyFreeSlots")}
          </ToggleButton>
          <ToggleButton
            active={showExpired}
            onClick={() => setShowExpired(!showExpired)}
          >
            {t("showExpired")}
          </ToggleButton>
        </FilterGroup>
      </div>

      <div className="col-12 d-flex gap-2 pt-3 mt-2">
        <button
          type="button"
          className="btn btn-sm btn-outline-gray"
          onClick={onReset}
          disabled={!hasActiveFilters}
        >
          {t("resetFilters")}
        </button>
        <button
          type="button"
          className="btn btn-sm bg-blue"
          onClick={onScrollToTable}
        >
          {t("applyFilters")}
        </button>
      </div>
    </div>
  );
};

export default TrainingFilterPanel;
